export const ENTRY_USER = 9999;
export const DEFAULT_PROFILE_IMAGE =
  "https://i.ibb.co/vmy2PYq/83fc4c6dca8298dc8e03ba63d35a9cae.jpg";

export enum KeyCode {
  enter = "Enter",
}

export enum Path {
  Home = "/",
  Chat = "/chat",
}
